import { useEffect, useState, useRef } from "preact/hooks";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import style from "./style.scss";
import {convertToRoman, getTimeFormatted, insertDataInStaticString} from "../../../utils"
import ExamQuestion from '../ExamQuestion'
import StudentTestReport from '../StudentTestReport'
import useDetectOutSideClick from '../../../customHooks/useDetectOutSideClick'
import DropArrow from "../../../assets/images/DropArrow.svg"
import TooltipArrow from "../../../assets/images/TooltipArrow.svg";
import SyncLoader from "../../../assets/images/SyncLoader.svg";
import ContentLoader from '../../../components/Common/ContentLoader'
import { textIdentifier } from "../../../components/Common/textIdentifier";

import {
  getTests,
  selectTest,
  fetchExamReport,
  getSelectTest,
  resetTest,
  launchTest,
  fetchStudentWiseReport,
  fetchExamQuestion,
  getAllAttempts,
  resetTestAttempts,
} from "../../../action"
import { Mixpanel } from "../../../Mixpanel";
import Markup from "../../../components/Common/Markup";
import ResetTestModal from "./ResetTestModal";
import SupportErrorReport from "../../Main/SupportErrorReport";
import StudentTable from "./StudentTable";

const Header = props => {
  return (
    <div className={style['test--header']}>
      <div className={style['header--left']}>
        <div className={style['back--logo']} onClick={() => props.goBackTest()}>
          <svg width="16.961" height="12.966" viewBox="0 0 16.961 12.966"><path style="fill:#4d4d4d;" d="M2.875,19.268l5.231-5.231A1.25,1.25,0,0,1,9.873,15.8L6.785,18.91H18.211a1.25,1.25,0,0,1,0,2.5H6.785L9.873,24.5a1.256,1.256,0,1,1-1.785,1.767L2.875,21.053A1.271,1.271,0,0,1,2.5,20.16,1.2,1.2,0,0,1,2.875,19.268Z" transform="translate(-2.5 -13.675)"/></svg>
        </div>
        <div className={style['test--name']}>{props.selectedTest.name}</div>
      </div>
    </div>
  )
}

const StudentTests = (props) => {
  const {language} = useSelector((state)=>state.userSession.user)
  const { match } = props
  const { params } = match
  const history = useHistory()
  let {
    selectedClass: paramsSelectedClass,
    testId: paramsSelelectedTest,
    chapterId: paramsSelectedChapter,
  } = params

  // let isTopicReport = match.path.indexOf("topic-report") > -1
  // console.log(isTopicReport,paramsSelectedChapter, "isTopicReport")
  const {
    selectedClass,
    selectedTest,
    testsView,
    examReport,
    userSession,
    testAttempts,
  } = useSelector((state) => state)

  const [studentList, setStudentList] = useState()
  const [selectedStudent, selectStudent] = useState()
  const [selectedAttemptStudent, selectAttemptStudent] = useState()
  const [dropdown, setDropdown] = useState(false)
  const [sortBy, changeSort] = useState("fname")
  const [showAttemptModal, setAttemptModal] = useState(false)
  const [resetTestModal , setResetTestModal] = useState(false)
  const [clickedStudent , setClickedStudent] = useState()

  const dispatch = useDispatch()
  const ref = useRef()

  useEffect(() => {
    if (!!selectedTest && selectedTest.id == paramsSelelectedTest) {
      // dispatch(fetchExamReport(paramsSelectedClass, selectedTest.id))
      Mixpanel.track("TeacherProduct_ExamwiseAnalyticsViewed", {
        "ExamID": selectedTest.id,
        "ExamName": selectedTest.name
      });
      Mixpanel.people.set({
        "$email": userSession.user.email,
        "TeacherID": userSession.user.id
      });
    }
    else {
      dispatch(getSelectTest(paramsSelectedClass))
    }
  }, [])

  useEffect(() => {
    if(!!testsView[paramsSelectedClass]){
      Object.values(testsView[paramsSelectedClass]).flat().every(testObj => {
        if(testObj.id == paramsSelelectedTest) {
          dispatch(selectTest(testObj))
          return false
        }
        else return true
      })
    }
  }, [testsView])

  useEffect(() => {
    if(!!selectedTest) dispatch(fetchExamReport(paramsSelectedClass, selectedTest.id))
  }, [selectedTest])

  // useEffect(() => {
  //   if(!!examReport && !!examReport[paramsSelelectedTest]) {
  //       let sortedStudents =
  //         sortBy == "fname"
  //           ? [...examReport[paramsSelelectedTest]].sort((a, b) =>
  //               (a.firstName + "" + a.lastName).localeCompare(
  //                 b.firstName + "" + b.lastName
  //               )
  //             )
  //           : sortBy == "lname"
  //           ? [...examReport[paramsSelelectedTest]].sort((a, b) =>
  //               (a.lastName + "" + a.firstName).localeCompare(
  //                 b.lastName + "" + b.firstName
  //               )
  //             )
  //           : sortBy == "low"
  //           ? [...examReport[paramsSelelectedTest]].sort((a, b) =>
  //               a.score == "Not Started" ||
  //               a.score == "Deadline Missed" ||
  //               a.score == null
  //                 ? 1
  //                 : b.score == null ||
  //                   b.score == "Not Started" ||
  //                   b.score == "Deadline Missed"
  //                 ? -1
  //                 : a.score == "Yet to submit"
  //                 ? -1
  //                 : b.score == "Yet to submit"
  //                 ? 1
  //                 : a.score > b.score
  //                 ? 1
  //                 : b.score > a.score
  //                 ? -1
  //                 : 0
  //             )
  //           : [...examReport[paramsSelelectedTest]].sort((a, b) =>
  //               a.score == "Not Started" ||
  //               a.score == "Deadline Missed" ||
  //               a.score == null
  //                 ? 1
  //                 : b.score == null ||
  //                   b.score == "Not Started" ||
  //                   b.score == "Deadline Missed"
  //                 ? -1
  //                 : a.score == "Yet to submit"
  //                 ? 1
  //                 : b.score == "Yet to submit"
  //                 ? -1
  //                 : a.score < b.score
  //                 ? 1
  //                 : b.score < a.score
  //                 ? -1
  //                 : 0
  //             );

  //             //[...studentList].sort((a,b) => a.score == "Not Started" || a.score == "Deadline Missed" || a.score == null? 1 : b.score== null || b.score == "Not Started" || b.score == "Deadline Missed" ? -1 : a.score=="Yet to submit" ? -1 : b.score == "Yet to submit" ? 1 : (a.score > b.score) ? 1 : ((b.score > a.score) ? -1 : 0)) :
  //           // [...studentList].sort((a,b) => a.score == "Not Started" || a.score == "Deadline Missed" || a.score == null? 1 : b.score== null || b.score == "Not Started" || b.score == "Deadline Missed" ? -1 : a.score=="Yet to submit" ? 1 : b.score == "Yet to submit" ? -1 : (a.score < b.score) ? 1 : ((b.score < a.score) ? -1 : 0))

  //       setStudentList([...sortedStudents])
  //   }
  // }, [examReport])

  const goBackTest = () => {
    dispatch(resetTest())
    history.push(`/${paramsSelectedClass}/tests`)
  }
  // const handleClickOutside = () => {
  //   setDropdown(false);
  // };
  // useDetectOutSideClick(ref, handleClickOutside);
  
  const handleModalClick = (value,student) => {
    setResetTestModal(value)
    if(student) setClickedStudent(student);
  }

  const handleRefreshTest = () => {
    setResetTestModal(false)
    dispatch(resetTestAttempts(paramsSelectedClass , selectedTest.id, clickedStudent.id))
    handleSyncButton()
  }
  // const timeConvert = (seconds) => {
  //     seconds = Number(seconds);
  //     var d = Math.floor(seconds / (3600 * 24));
  //     var h = Math.floor(seconds % (3600 * 24) / 3600);
  //     var m = Math.floor(seconds % 3600 / 60);
  //     var s = Math.floor(seconds % 60);

  //     var dDisplay = d > 0 ? d + (d == 1 ? textIdentifier["day"][language]+" " : textIdentifier["days"][language]+" ") : "";
  //     var hDisplay = h > 0 ? h + (h == 1 ? textIdentifier["hr"][language]+" " : textIdentifier["hr"][language]+" ") : "";
  //     var mDisplay = m > 0 ? m + (m == 1 ? textIdentifier["min"][language]+" " : textIdentifier["min"][language]+" ") : "";
  //     return !!seconds ? dDisplay + hDisplay + mDisplay : undefined;
  // }

  const selectExam = (student, attempt) => {
    const tempStudent = {...student}
    if(attempt && attempt.attemptOrder) {
      dispatch(fetchStudentWiseReport(paramsSelelectedTest, student.id, attempt.attemptOrder))
      dispatch(fetchExamQuestion(selectedTest.configTypeIds, student.id, 0, attempt.attemptOrder))
      tempStudent.score = attempt.marksObtained
    }
    else {
      dispatch(fetchStudentWiseReport(paramsSelelectedTest, student.id))
      dispatch(fetchExamQuestion(selectedTest.configTypeIds, student.id, 0))
    }
    selectStudent(tempStudent)
    selectAttemptStudent()
    setAttemptModal(false)
  }

  const selectStudentTest = student => {
    if(student.status != "Yet to submit" && (student.status != "Not Started" || student.status != "Deadline Missed")) {
      if(student.attemptOrder) {
        dispatch(getAllAttempts(student.id))
        selectAttemptStudent(student)
        setAttemptModal(true)
      }
      else {
        selectExam(student)
      }
    }
  }
  const handleSyncButton = async() => {
    if(studentList){
      setStudentList()
      dispatch(fetchExamReport(paramsSelectedClass, selectedTest.id))
    }
  }
  const getSubmittedCount = (students) => {
    // console.log("students",students)
    let count = 0;
    students.map(student => {
      if(student.isCompleted) count++;
    })
    return count;
  }

  const getNotStartedCount = (students) => {
    let count = 0;
    students.map(student => {
      if(!student.hasStarted) count++;
    })
    return count;
  
  }
  // useEffect(() => {
  //   if(studentList && studentList.length > 0) {
  //     let sortedStudents= sortBy == "fname" ?
  //       [...examReport[paramsSelelectedTest]].sort((a,b) => (a.firstName+""+a.lastName).localeCompare( b.firstName+""+b.lastName)) :
  //       sortBy == "lname" ?
  //         [...examReport[paramsSelelectedTest]].sort((a,b) => (a.lastName+""+a.firstName).localeCompare( b.lastName+""+b.firstName)) :
  //         sortBy == "low" ?
  //           [...studentList].sort((a,b) => a.score == "Not Started" || a.score == "Deadline Missed" || a.score == null? 1 : b.score== null || b.score == "Not Started" || b.score == "Deadline Missed" ? -1 : a.score=="Yet to submit" ? -1 : b.score == "Yet to submit" ? 1 : (a.score > b.score) ? 1 : ((b.score > a.score) ? -1 : 0)) :
  //           [...studentList].sort((a,b) => a.score == "Not Started" || a.score == "Deadline Missed" || a.score == null? 1 : b.score== null || b.score == "Not Started" || b.score == "Deadline Missed" ? -1 : a.score=="Yet to submit" ? 1 : b.score == "Yet to submit" ? -1 : (a.score < b.score) ? 1 : ((b.score < a.score) ? -1 : 0))
  //     setStudentList([...sortedStudents])
  //     let sortType = sortBy == "high" ? "Score Descending" : sortBy == "low" ? "Score Ascending" : sortBy == "lname" ? "LastName" : "FirstName";
  //     Mixpanel.track("TeacherProduct_SortPerformed", {
  //       "SortPerformedFrom": "ExamAnalytics",
  //       "SortType": sortType
  //     });
  //     Mixpanel.people.set({
  //       "$email": userSession.user.email,
  //       "TeacherID": userSession.user.id
  //     });
  //     // console.log("sortedStudents",sortedStudents)
  //   }
  // },[sortBy])

  useEffect(() => {
    if(selectedStudent) {
      Mixpanel.track("TeacherProduct_StudentExamAnalyticsViewed", {
        "ExamID": selectedTest.id,
        "ExamName": selectedTest.name,
        "StudentID": selectedStudent.id
      });
      Mixpanel.people.set({
        "$email": userSession.user.email,
        "TeacherID": userSession.user.id
      });
    }
  }, [selectedStudent]);

  return (
    <div className={style['test--students']}>
      <SupportErrorReport />
      {
        resetTestModal && clickedStudent && <ResetTestModal handleModalClick={handleModalClick} selectedStudent={clickedStudent} selectedTest={selectedTest} language={language} handleRefreshTest = {handleRefreshTest}/>
      }
      {!!!selectedStudent ?
        <>
          {!!selectedTest && (
            <div>
              <Header
                selectedTest={selectedTest}
                goBackTest={goBackTest}
              />
            </div>
          )}
          {/* <div className={style["test--info"]}>
            <div className={style["class--name"]}>{textIdentifier["class"][language]} : {!!selectedClass && selectedClass.name}</div>
            <div className={style["student--numbers"]}>{!!studentList && studentList.length} {textIdentifier["students-in-the-class"][language]}</div>
          </div> */}
          {selectedTest && <StudentTable 
            paramsSelectedClass={paramsSelectedClass} 
            reportId={paramsSelelectedTest}
            // paramsSelectedChapter={paramsSelectedChapter}
            studentList={studentList} 
            handleSyncButton={handleSyncButton}
            getSubmittedCount={getSubmittedCount}
            getNotStartedCount={getNotStartedCount}
            selectStudentTest={selectStudentTest}
            setStudentList={setStudentList}
            disableTimer={selectedTest.disableTimer}
            redoEnabled={selectedTest.redoEnabled}
            examReport={examReport} 
          />}
        </> :
        <StudentTestReport
          selectedTest={selectedTest}
          selectStudent={selectStudent}
          selectedStudent={selectedStudent}
          selectedClass={paramsSelectedClass} />
      }
      {showAttemptModal &&
        <div className={style["modal-container"]}>
          <div class={style["attempt-container"]}>
            <div class={style["attempt-header"]}>
              <div class={style["exam-name"]}>{selectedTest.name}</div>
              <div class={style["head-left"]}>
                <div class={style["exam-marks"]}>{insertDataInStaticString(textIdentifier['total-n-marks'][language],[selectedTest.maximumMarks])}</div>
                <div class={style["close-md"]} onClick={() => setAttemptModal(false)}><svg width="20" height="20" viewBox="0 0 20 20" fill="none"><path d="M5 15L15 5M5 5L15 15" stroke="#9E9E9E" strokeLinecap="round" strokeLinejoin="round"/></svg></div>
              </div>
            </div>
            <div class={style["attempt-list"]}>
              {testAttempts && testAttempts[selectedTest.id] && testAttempts[selectedTest.id][selectedAttemptStudent.id] && testAttempts[selectedTest.id][selectedAttemptStudent.id].map(attempt => {
                return (
                  <div class={[style["attempt-card"],attempt.isAiEvaluating && style["attempt-card--disabled"]].join(" ")} key={attempt.id} onClick={() => selectExam(selectedAttemptStudent, attempt)}>
                    <div class={style["attempt-info"]}>
                      <div class={style["high-font"]}>{insertDataInStaticString(textIdentifier['attempt-n'][language],[attempt.attemptOrder])}</div>
                      <div class={style["low-font"]}>{insertDataInStaticString(textIdentifier['on-time'][language],[getTimeFormatted(attempt.attemptTime)])}</div>
                      {attempt.isAiEvaluating && <div class={style["high-font"]}>{ textIdentifier["ai-evaluation-in-progress"][language]} </div> }
                      {!attempt.isAiEvaluating && <div class={style["high-font"]}><Markup markup={insertDataInStaticString(textIdentifier['n-mark(s)'][language],[attempt.marksObtained])} /></div>}
                      {!attempt.isAiEvaluating && <div class={style["low-font"]}>{textIdentifier['obtained'][language]}</div>}
                    </div>
                    {!attempt.isAiEvaluating &&  <div><svg width="16" height="16" viewBox="0 0 16 16" fill="none"><path d="M5.5 3L10.5 8L5.5 13" stroke="#858585" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/></svg></div>}
                  </div>
                )
              })}
            </div>
          </div>
        </div>
      }
    </div>
  );
};

export default StudentTests;
